/* import __COLOCATED_TEMPLATE__ from './invite-teammates-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();